import type { LocationQuery } from 'vue-router'
import { authRoutes } from '../router'
import { postGetBody, type ProblemDetailsResponse } from './api'
import { authenticated, type AuthenticatedResponse } from './authentication-service'

export function loginWithHealthstream() {
  const authState = window.crypto.randomUUID()
  localStorage.setItem('state', authState)
  window.location.href = `https://login.hstream.com/v2/oauth2/authorize?response_type=code&client_id=3sffkuifrrq729ufs1sqdg4mae&scope=openid&state=${authState}&redirect_uri=${window.location.origin}/healthstream/`
}

export function checkForValidAuthCode(query: LocationQuery) {
  const authCode = query.code?.toString()
  if (!authCode) {
    return
  }
  const stateQuery = query.state?.toString()
  const state = localStorage.getItem('state')
  if (!(stateQuery && state && stateQuery === state)) {
    throw new Error('Invalid auth code state')
  }

  return authCode
}

export async function handleHealthStreamAuthCode(authCode: string): Promise<string> {
  const { healthStreamOrganizationId, healthStreamUserId, healthStreamCourseId, ossoCourseId } = getHealthStreamParams()
  localStorage.removeItem('healthStreamOrganizationId')
  localStorage.removeItem('healthStreamUserId')
  localStorage.removeItem('healthStreamCourseId')
  localStorage.removeItem('healthStreamOssoCourseId')

  const healthStreamCourseContext =
    healthStreamOrganizationId && healthStreamUserId && healthStreamCourseId && ossoCourseId
      ? { organizationId: healthStreamOrganizationId, userId: healthStreamUserId, courseId: healthStreamCourseId, ossoCourseId }
      : null

  const response = await postGetBody<AuthenticatedResponse | ProblemDetailsResponse>('login-hstream', {
    authCode,
    healthStreamCourseContext
  })
  if (response && 'user' in response) {
    return await authenticated(response, 'health-stream')
  } else if (response?.title === 'Missing HealthStream information') {
    return authRoutes.healthStreamMissingLogininfo.path
  }
  return authRoutes.login.path
}

function getHealthStreamParams() {
  const healthStreamOrganizationId = localStorage.getItem('healthStreamOrganizationId')
  const healthStreamUserId = localStorage.getItem('healthStreamUserId')
  const healthStreamCourseId = localStorage.getItem('healthStreamCourseId')
  const ossoCourseId = localStorage.getItem('healthStreamOssoCourseId')
  return { healthStreamOrganizationId, healthStreamUserId, healthStreamCourseId, ossoCourseId }
}
